/**
 * Все провайдеры подключаются в этом файле.
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LazyMotion } from 'framer-motion';
import { ReactNode, useState } from 'react';

const makeQueryClient = () =>
    new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnMount: false,
                refetchOnWindowFocus: false,
            },
        },
    });

const Providers = ({ children }: { children: ReactNode }) => {
    const [queryClient] = useState(makeQueryClient);

    return (
        <LazyMotion features={() => import('@/framer-motion-features').then((m) => m.default)} strict>
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </LazyMotion>
    );
};

export default Providers;
